import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import TextField from '@material-ui/core/TextField';

const TooltipTextField = ({
  id,
  label,
  fullWidth,
  placeholder,
  inputProps,
  InputLabelProps,
  value,
  onChange,
  disabled,
  tooltipContent,
  tooltipTriggerLength,
  className,
  onKeyDown = () => {},
  required = false,
  error,
  helperText
}) => {
  const shouldShowTooltip = value && value.length > tooltipTriggerLength;

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={
        shouldShowTooltip ? (
          <Tooltip id="tooltip">{tooltipContent}</Tooltip>
        ) : (
          <></>
        )
      }
      trigger={shouldShowTooltip ? ['hover', 'focus'] : []}
    >
      {/* Wrapping div keeps MUI structure intact */}
      <div style={{ display: 'inline-block', width: '100%' }}>
        <TextField
          id={id}
          label={label}
          fullWidth={fullWidth}
          placeholder={placeholder}
          inputProps={inputProps}
          InputLabelProps={InputLabelProps}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={className}
          required={required}
          error={!!error}
          helperText={helperText}
          onKeyDown={onKeyDown}
        />
      </div>
    </OverlayTrigger>
  );
};

export default TooltipTextField;
